module.exports = __webpack_public_path__ + "static/media/ajeeth.9f1600e9.png";